export type BroadcastMessage = {
  type: 'auth.session_refreshed'
  /** `null` signals auth loss (logout). Otherwise carries the current snapshot. */
  auth: { access_token: string; expires_at: number; user_id: string } | null
}
type BroadcastPayload = {
  [MESSAGE_PREFIX]: string
  payload: BroadcastMessage
}

type BroadcastListener = (message: BroadcastMessage) => void

export class BroadcastService {
  private channel: BroadcastChannel | null = null
  private listeners: Set<BroadcastListener> = new Set()

  constructor() {
    try {
      this.channel = new BroadcastChannel('kidsout')
      this.channel.onmessage = event => {
        if (isBroadcastPayload(event.data)) {
          const { payload } = event.data
          for (const listener of this.listeners) {
            listener(payload)
          }
        }
      }
    } catch {}
  }

  [Symbol.dispose]() {
    this.channel?.close()
    this.channel = null
  }

  addListener(listener: BroadcastListener): Disposable {
    this.listeners.add(listener)

    return {
      [Symbol.dispose]: () => {
        this.listeners.delete(listener)
      },
    }
  }

  send(message: BroadcastMessage) {
    const payload: BroadcastPayload = {
      [MESSAGE_PREFIX]: '1',
      payload: message,
    }
    this.channel?.postMessage(payload)
  }
}

const MESSAGE_PREFIX = 'kidsout-message-191A4316-3F81-446C-99C6-306C8BF21435'
const isBroadcastPayload = (message: unknown): message is BroadcastPayload => {
  if (typeof message !== 'object' || message === null) return false
  return MESSAGE_PREFIX in message
}
